import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import pageTitleMixin from './plugins/titleMixin.js'


loadFonts()

const app = createApp(App);
app.mixin(pageTitleMixin);
app.use(router)
app.use(vuetify)
app.mount('#app')
